export default __webpack_public_path__ + "static/media/159.ebb9e346.png";